import { useFormik } from "formik";
import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { QUERY } from "./licenses.graphql";
import { type LicensesScreenFormState } from "./licenses.types";
import { type licenses_LicensesQuery } from "../../__generated__/licenses_LicensesQuery.graphql";
import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { ValidatedField } from "../../components/ValidatedField";
import { SelectSingleAccountField } from "../../features/accounts/select-single-account-field";
import { SelectSingleAccountFieldState } from "../../features/accounts/select-single-account-field/select-single-account-field.types";
import { LicensesTable } from "../../features/licenses/licenses-table";
import { Spacing32 } from "../../features/licenses/licenses-table/licenses-table.styles";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const LicensesScreen = () => {
	const { t } = useTranslation("common");
	const formik = useFormik<LicensesScreenFormState>({
		initialValues: {},
		onSubmit: () => {},
	});

	const data = useLazyLoadQuery<licenses_LicensesQuery>(
		QUERY,
		{},
		{ fetchPolicy: "store-or-network" },
	);

	const canRead = useHasPermissions(["UserInAccountPermission_LicenseAdmin_Read"]);

	if (!canRead) {
		return <NoAccess />;
	}

	return (
		<BaseScreen title={t("licenses.screenTitle")}>
			<ValidatedField<LicensesScreenFormState, SelectSingleAccountFieldState>
				required
				name={"selectAccountFieldState"}
				label={t("licenses.account")}
				placeholder={t("licenses.selectAccount")}
				formikConfig={formik}
				component={(renderConfig) => <SelectSingleAccountField {...renderConfig} />}
			/>

			<Spacing32 />
			<LicensesTable
				licensesFragmentRef={data}
				showDeleteButton
				accountId={formik.values.selectAccountFieldState?.id}
				accountName={formik.values.selectAccountFieldState?.name}
			/>
		</BaseScreen>
	);
};
